import { Component } from "@angular/core";

@Component({
    selector:'questao-app-root',
    template:'<router-outlet></router-outlet>'
})
export class QuestaoAppComponent{}